import { useNavigate } from "react-router-dom";
import { Button } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";

function TermsOfUse() {
  const navigate = useNavigate();

  return (
    <div
      className="min-h-screen w-full py-8 px-4 sm:px-6 lg:px-8"
      style={{
        background: "linear-gradient(180deg, #FCE8E9 0%, #FFF 100%)",
      }}
    >
      <div className="max-w-4xl mx-auto">
        <div className="mb-6">
          <Button
            type="text"
            icon={<ArrowLeftOutlined />}
            onClick={() => navigate(-1)}
            className="text-[#e61f26] hover:text-[#c01a21] font-Poppins font-[500]"
          >
            Back
          </Button>
        </div>

        <div className="bg-white rounded-2xl shadow-lg p-6 sm:p-8 md:p-12">
          <div className="mb-8 border-b border-gray-200 pb-6">
            <h1 className="font-Poppins text-3xl sm:text-4xl md:text-5xl font-[700] text-[#010101] mb-3">
              Terms of Use
            </h1>
            <p className="font-Poppins text-lg sm:text-xl font-[600] text-[#e61f26]">
              ProTVGuide SportsBot
            </p>
            <p className="font-Poppins text-sm sm:text-base font-[400] text-[#667085] mt-2">
              Effective Date: October 1, 2025
            </p>
          </div>

          <div className="mb-6 p-4 bg-[#FCE8E9] rounded-lg border-l-4 border-[#e61f26]">
            <p className="font-Poppins text-sm sm:text-base font-[500] text-[#344054]">
              By using ProTVGuide SportsBot ("the Bot"), you agree to the following:
            </p>
          </div>

          <div className="space-y-8">
            <section>
              <h2 className="font-Poppins text-xl sm:text-2xl font-[700] text-[#010101] mb-1 flex items-center">
                <span className="inline-block w-8 h-8 sm:w-10 sm:h-10 bg-[#e61f26] text-white rounded-full flex items-center justify-center mr-3 text-base sm:text-lg">
                  1
                </span>
                Service Description
              </h2>
              <div className="ml-11 sm:ml-13 space-y-2">
                <p className="font-Poppins text-sm sm:text-base font-[400] text-[#344054] leading-relaxed text-left">
                  The Bot provides automated sports schedules, chat features, and related services within Discord and Telegram.
                </p>
                <p className="font-Poppins text-sm sm:text-base font-[400] text-[#344054] leading-relaxed text-left">
                  Some features are free; others require subscription or credits.
                </p>
              </div>
            </section>

            <section>
              <h2 className="font-Poppins text-xl sm:text-2xl font-[700] text-[#010101] mb-1 flex items-center">
                <span className="inline-block w-8 h-8 sm:w-10 sm:h-10 bg-[#e61f26] text-white rounded-full flex items-center justify-center mr-3 text-base sm:text-lg">
                  2
                </span>
                User Responsibilities
              </h2>
              <div className="ml-11 sm:ml-13 space-y-2">
                <p className="font-Poppins text-sm sm:text-base font-[400] text-[#344054] leading-relaxed text-left">
                  You must not misuse the Bot (e.g., spam, malicious activity, violating Discord/Telegram terms).
                </p>
                <p className="font-Poppins text-sm sm:text-base font-[400] text-[#344054] leading-relaxed text-left">
                  You are responsible for managing your server/group settings when using the Bot.
                </p>
              </div>
            </section>

            <section>
              <h2 className="font-Poppins text-xl sm:text-2xl font-[700] text-[#010101] mb-1 flex items-center">
                <span className="inline-block w-8 h-8 sm:w-10 sm:h-10 bg-[#e61f26] text-white rounded-full flex items-center justify-center mr-3 text-base sm:text-lg">
                  3
                </span>
                Data Privacy
              </h2>
              <div className="ml-11 sm:ml-13 space-y-2">
                <p className="font-Poppins text-sm sm:text-base font-[400] text-[#344054] leading-relaxed text-left">
                  We take privacy seriously and will never share your data with third parties.
                </p>
                <p className="font-Poppins text-sm sm:text-base font-[400] text-[#344054] leading-relaxed text-left">
                  You may request data deletion at any time (see Privacy Policy).
                </p>
              </div>
            </section>

            <section>
              <h2 className="font-Poppins text-xl sm:text-2xl font-[700] text-[#010101] mb-1 flex items-center">
                <span className="inline-block w-8 h-8 sm:w-10 sm:h-10 bg-[#e61f26] text-white rounded-full flex items-center justify-center mr-3 text-base sm:text-lg">
                  4
                </span>
                Payments & Credits
              </h2>
              <div className="ml-11 sm:ml-13 space-y-2">
                <p className="font-Poppins text-sm sm:text-base font-[400] text-[#344054] leading-relaxed text-left">
                  Subscriptions and chat credits are optional.
                </p>
                <p className="font-Poppins text-sm sm:text-base font-[400] text-[#344054] leading-relaxed text-left">
                  All payments are final except where required by law.
                </p>
              </div>
            </section>

            <section>
              <h2 className="font-Poppins text-xl sm:text-2xl font-[700] text-[#010101] mb-1 flex items-center">
                <span className="inline-block w-8 h-8 sm:w-10 sm:h-10 bg-[#e61f26] text-white rounded-full flex items-center justify-center mr-3 text-base sm:text-lg">
                  5
                </span>
                Availability
              </h2>
              <div className="ml-11 sm:ml-13 space-y-2">
                <p className="font-Poppins text-sm sm:text-base font-[400] text-[#344054] leading-relaxed text-left">
                  We aim for 24/7 reliability but do not guarantee uptime.
                </p>
                <p className="font-Poppins text-sm sm:text-base font-[400] text-[#344054] leading-relaxed text-left">
                  Features may change or be discontinued at any time.
                </p>
              </div>
            </section>

            <section>
              <h2 className="font-Poppins text-xl sm:text-2xl font-[700] text-[#010101] mb-1 flex items-center">
                <span className="inline-block w-8 h-8 sm:w-10 sm:h-10 bg-[#e61f26] text-white rounded-full flex items-center justify-center mr-3 text-base sm:text-lg">
                  6
                </span>
                Limitation of Liability
              </h2>
              <div className="ml-11 sm:ml-13 space-y-2">
                <p className="font-Poppins text-sm sm:text-base font-[400] text-[#344054] leading-relaxed text-left">
                  The Bot is provided "as is."
                </p>
                <p className="font-Poppins text-sm sm:text-base font-[400] text-[#344054] leading-relaxed text-left">
                  We are not liable for any damages resulting from use, downtime, or reliance on the service.
                </p>
              </div>
            </section>

            <section>
              <h2 className="font-Poppins text-xl sm:text-2xl font-[700] text-[#010101] mb-1 flex items-center">
                <span className="inline-block w-8 h-8 sm:w-10 sm:h-10 bg-[#e61f26] text-white rounded-full flex items-center justify-center mr-3 text-base sm:text-lg">
                  7
                </span>
                Updates to Terms
              </h2>
              <div className="ml-11 sm:ml-13 space-y-2">
                <p className="font-Poppins text-sm sm:text-base font-[400] text-[#344054] leading-relaxed text-left">
                  We may update these Terms periodically. Continued use of the Bot means acceptance of updated Terms.
                </p>
              </div>
            </section>
          </div>

          <div className="mt-10 pt-8 border-t border-gray-200">
            <div className="bg-[#FCE8E9] rounded-lg p-4 sm:p-6">
              <p className="font-Poppins text-xs sm:text-sm font-[500] text-[#344054] text-center">
                If you have any questions about these Terms of Use, please contact us at{" "}
                <a
                  href="mailto:support@protvguide.com"
                  className="text-[#e61f26] hover:underline font-[600]"
                >
                  support@protvguide.com
                </a>
              </p>
            </div>
          </div>
        </div>

        <div className="mt-6 text-center">
          <p className="font-Poppins text-xs sm:text-sm font-[400] text-[#667085]">
            © 2025 ProTVGuide SportsBot. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
}

export default TermsOfUse;